export default "__VITE_ASSET__DYtb3ux8__"